import axios from 'axios';
import { API, authHeaders } from './client';

export const getSections = () =>
  axios.get(`${API}/cms/sections`).then(r => r.data);

export const updateSection = (sectionId, data, token) =>
  axios.put(`${API}/cms/sections/${sectionId}`, data, authHeaders(token)).then(r => r.data);

export const reorderSections = (orderData, token) =>
  axios.put(`${API}/cms/sections/reorder`, orderData, authHeaders(token)).then(r => r.data);
